import { Link } from "react-router-dom";

function Fees() {
  return (
    <div style={{ textAlign: "center", padding: "50px 20px" }}>

      <h2 style={{ color: "#002387", marginBottom: "10px" }}>
        Fees Structure
      </h2>

      <p style={{ color: "#000000", marginBottom: "30px" }}>
        Fee details are available on request. Please contact the college for accurate and updated information.
      </p>

      {/* CENTER BOX */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >

        <div
          style={{
            maxWidth: "350px",
            width: "100%",
            background: "#fff",
            padding: "25px",
            borderRadius: "12px",
            boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
            textAlign: "center",
          }}
        >
          <h3 style={{ color: "#ff6600", marginBottom: "10px" }}>
            B.A / B.Sc / B.Com
          </h3>

          <p style={{ color: "#000000", fontSize: "14px" }}>
            Fees may vary based on course, category, and government rules.
          </p>

          <p style={{ margin: "15px 0", fontWeight: "bold" }}>
            👉 Contact college for details
          </p>

          <Link
            to="/contact"
            style={{
              display: "inline-block",
              padding: "10px 20px",
              background: "#002387",
              color: "#fff",
              borderRadius: "6px",
              textDecoration: "none",
              marginTop: "10px",
            }}
          >
            Enquire Now
          </Link>
        </div>

      </div>

    </div>
  );
}

export default Fees;